import { createContext, useContext } from 'react';
import { InquirySentIndicator } from '../types/api/v4/trips';

const inquiryIndicatorsContext = createContext<InquirySentIndicator[]>([]);

export const InquiryIndicatorsProvider = inquiryIndicatorsContext.Provider;

export const useInquiryIndicatorsContext = (): InquirySentIndicator[] => {
  const context = useContext(inquiryIndicatorsContext);
  if (context == null) {
    throw new Error('useInquiryIndicatorsContext must be used within a InquiryIndicatorsProvider');
  }
  return context;
};
